module.exports = __webpack_public_path__ + "img/AI_13.3b69adcc.jpg";